/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const TitleLabels = {
  color: `${Palette.PrimaryGray._700}`,
  height: '20px',
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
};

export const RequirementsLabels = {
  color: `${Palette.PrimaryGray._500}`,
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '20px',
};
